import React, { useEffect } from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import './main.css';

const Common = () => {
  useEffect(() => {
    const faders = document.querySelectorAll('.fade-in');
  
    const appearOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px"
    };
  
    const appearOnScroll = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('show');
        observer.unobserve(entry.target);
      });
    }, appearOptions);
  
    faders.forEach((fader, index) => {
      const el = fader as HTMLElement; // ✅ típus assertion
      el.style.transitionDelay = `${index * 0.2}s`;
      appearOnScroll.observe(el);
    });
  
  }, []);
  return (
    <section className="services-section">
      <div className="services-content">

        <div className="services-challenges">
          <div className="services-header">
            <h3 className='fade-in'>
              Common challenges that organisations experience in the context of the risks 
              associated with human behaviour include understanding, managing and mitigating 
              the risks associated with:
            </h3>
          </div>

          <div className="services-grid">
            {/* Első oszlop */}
            <div>
              <div className="services-item fade-in">
                <CheckCircleIcon className="check-icon" />
                <p className="text-body ">
                  Employees who express threats against organisations or individuals and/or who hold grievances in relation to their experience.
                </p>
              </div>

              <div className="services-item fade-in">
                <CheckCircleIcon className="check-icon" />
                <p className="text-body">
                  Ensuring safety compliance in dangerous industries such as construction and mining.
                </p>
              </div>

              <div className="services-item fade-in">
                <CheckCircleIcon className="check-icon" />
                <p className="text-body">
                  Recruiting high level employees who will have access to sensitive information and manage multiple employees.
                </p>
              </div>

              <div className="services-item fade-in">
                <CheckCircleIcon className="check-icon" />
                <p className="text-body">Employees with mental health concerns.</p>
              </div>
            </div>

            {/* Második oszlop */}
            <div>
              <div className="services-item fade-in">
                <CheckCircleIcon className="check-icon" />
                <p className="text-body">Maintaining culture within an organisation.</p>
              </div>

              <div className="services-item fade-in">
                <CheckCircleIcon className="check-icon" />
                <p className="text-body">
                  Investigating and managing complaints of bullying, harassment and gender-based violence.
                </p>
              </div>

              <div className="services-item fade-in">
                <CheckCircleIcon className="check-icon" />
                <p className="text-body">
                  Managing employees who have engaged in acts of violence or abuse, threatened or actual, either within or external to the organisation.
                </p>
              </div>

              <div className="services-item fade-in">
                <CheckCircleIcon className="check-icon" />
                <p className="text-body">
                  Understanding, assessing and managing concerns in relation to insider risk and corporate espionage.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Common;
